module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};



//////////////////
// WEBPACK FOOTER
// ./~/gatsby/~/core-js/library/modules/_is-object.js
// module id = 51
// module chunks = 168707334958949